(function () {
  'use strict';

  angular
    .module('morningFlightAfterNightFlight')
    .controller('morningFlightAfterNightFlightCtrl', morningFlightAfterNightFlightCtrl);

  function morningFlightAfterNightFlightCtrl(CommonMasterData, morningFlightAfterNightFlightService ,MessageService, $compile,$scope,StorageServices,TabService,applicationConstants) {
    var vm = this;
    vm.ctrlName = 'morningFlightAfterNightFlightCtrl';

    vm.model = {
      searchPanelToggle: true,
      width: window.screen.width,
      height:window.screen.height,
      searchOnGoing: false,
      totalNumberOfRecords:null,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        crewType: null,
        autoOrManual : null

      },
      masterList: {
        crewTypeList: [],
        fromDateFormatInvalid: false,
        toDateFormatInvalid: false,
        fromDateAfterToDate: false,
        autoManualList : [{'autoOrManualCode':'M', 'autoOrManualDesc':'Manual'}, {'autoOrManualCode':'A', 'autoOrManualDesc':'Auto'}]

      },
      lastSearchDates:{
        fromDate:null,
        toDate:null
      },
      morningFlightAfterNightFlightList: [],
      initialSearchDone: false
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    var dataObject = [];
    var hotSettings = [];
    var hot;

    vm.submitSearch = function (params) {
      morningFlightAfterNightFlightService.searchMorningFlightAfterNightFlight(params,
        function (response) {
          vm.model.lastSearchDates.fromDate = vm.model.searchCriteria.fromDate;
          vm.model.lastSearchDates.toDate = vm.model.searchCriteria.toDate;
          vm.model.morningFlightAfterNightFlightList = response.morningFlightAfterNightFlightResponseDTOS;
          vm.model.searchPanelToggle = false;
          vm.model.totalNumberOfRecords = response.morningFlightAfterNightFlightResponseDTOS.length;
          dataObject = vm.dataObject();
          hotSettings = vm.hotSettings();
          hot = new Handsontable(hotElement, hotSettings);
          $compile(hotElement)($scope);
        },
        function (error) {
          MessageService.error(error[0]);
        }
      );
    };

    vm.dataObject = function () {
      var dataObject = [];

      for (var i in vm.model.morningFlightAfterNightFlightList) {
        dataObject.push({
          ROW_NUMBER : parseInt(i)+1,
          CREW_NAME: vm.model.morningFlightAfterNightFlightList[i].crewName,
          CREW_ID: vm.model.morningFlightAfterNightFlightList[i].crewID,
          CREW_TYPE_CODE: vm.model.morningFlightAfterNightFlightList[i].crewType,
          NIGHT_FLIGHT_ORIGIN: vm.model.morningFlightAfterNightFlightList[i].nightFlightOrigin,
          NIGHT_FLIGHT_DESTINATION: vm.model.morningFlightAfterNightFlightList[i].nightFlightDestination,
          NIGHT_FLIGHT_DEPARTURE: vm.model.morningFlightAfterNightFlightList[i].nightFlightDeparture,
          NIGHT_FLIGHT_ARRIVAL: vm.model.morningFlightAfterNightFlightList[i].nightFlightArrival,
          MORNING_FLIGHT_ORIGIN: vm.model.morningFlightAfterNightFlightList[i].morningFlightOrigin,
          MORNING_FLIGHT_DESTINATION: vm.model.morningFlightAfterNightFlightList[i].morningFlightDestination,
          MORNING_FLIGHT_DEPARTURE: vm.model.morningFlightAfterNightFlightList[i].morningFlightDeparture,
          MORNING_FLIGHT_ARRIVAL: vm.model.morningFlightAfterNightFlightList[i].morningFlightArrival,
          RN_FL1: vm.model.morningFlightAfterNightFlightList[i].rnFl1,
          RN_FL2: vm.model.morningFlightAfterNightFlightList[i].rnFl2,
        })
      }
      return dataObject;
    };

    vm.hotSettings = function () {
      var hotSettings = {
        data: dataObject,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        manualColumnResize: true,
        copyRowsLimit: 1000000,
        colWidths: [vm.model.width * 0.05, vm.model.width * 0.07, vm.model.width * 0.05, vm.model.width * 0.05, vm.model.width * 0.05, vm.model.width * 0.05, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.05, vm.model.width * 0.05, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.05, vm.model.width * 0.05],
        columns: [
          {
            data: 'ROW_NUMBER',
            type: 'numeric',
            readOnly: true
          },
          {
            data: 'CREW_NAME',
            renderer: 'html',
            readOnly: true
          }, {
            data: 'CREW_ID',
            type: 'text',
            readOnly: true
          },  {
            data: 'CREW_TYPE_CODE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'NIGHT_FLIGHT_ORIGIN',
            type: 'text',
            readOnly: true
          },
          {
            data: 'NIGHT_FLIGHT_DESTINATION',
            type: 'text',
            readOnly: true
          },
          {
            data: 'NIGHT_FLIGHT_DEPARTURE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'NIGHT_FLIGHT_ARRIVAL',
            type: 'text',
            readOnly: true
          },
          {
            data: 'MORNING_FLIGHT_ORIGIN',
            type: 'text',
            readOnly: true
          },
          {
            data: 'MORNING_FLIGHT_DESTINATION',
            type: 'text',
            readOnly: true
          },
          {
            data: 'MORNING_FLIGHT_DEPARTURE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'MORNING_FLIGHT_ARRIVAL',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RN_FL1',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RN_FL2',
            type: 'text',
            readOnly: true
          },],

        stretchH: 'all',
        width: vm.model.width * 0.99,
        autoWrapRow: true,
        height: vm.model.height,
        rowHeaders: true,
        colHeaders: [
          '',
          'Crew Name',
          'Crew Id',
          'Crew Type',
          'Night Flight Origin',
          'Night Flight Destination',
          'Night Flight Departure',
          'Night Flight Arrival',
          'Morning Flight Origin',
          'Morning Flight Destination',
          'Morning Flight Departure',
          'Morning Flight Arrival',
          'RN FL1',
          'RN FL2',
        ]
      };

      return hotSettings;
    };

    var hotElement = document.querySelector('#hot');


    function setDateValidationFlags() {
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }


    vm.changeSearchField = function (searchParams, flag) {
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;

        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

    };


    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    (function () {
      CommonMasterData.getCrewTypeList(function (crewTypeList) {
        vm.model.masterList.crewTypeList = crewTypeList;
      }, function () {
        console.log('Crew Type list retrieval error');
      });

    })();
  }
}());
